import { useState } from "react";
import { faqs } from "@/mocks/faqs";
import SectionHeading from "./SectionHeading";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="w-full bg-background-50 px-4 md:px-8 py-14 md:py-20">
      <div className="w-full">
        <SectionHeading
          eyebrow="常见问题"
          title="吃瓜之前，先看这几条"
          desc="关于内容来源、更新频率和投稿方式，我们把最常被问到的问题整理在这里。"
          align="center"
        />

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <article
                key={item.q}
                className={`rounded-lg border transition-colors ${
                  isOpen
                    ? "border-primary-300 bg-primary-50/60"
                    : "border-background-200 bg-background-100/50 hover:border-primary-200"
                }`}
              >
                <h3>
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpenIndex(isOpen ? -1 : index)}
                    className="w-full flex items-center justify-between gap-4 text-left px-4 md:px-5 py-4 cursor-pointer"
                  >
                    <span className="font-heading font-bold text-foreground-950 text-sm md:text-base">
                      {item.q}
                    </span>
                    <span
                      className={`shrink-0 w-7 h-7 flex items-center justify-center rounded-full text-base transition-colors ${
                        isOpen
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                    </span>
                  </button>
                </h3>
                {isOpen && (
                  <p className="px-4 md:px-5 pb-5 text-sm text-foreground-700 leading-relaxed">
                    {item.a}
                  </p>
                )}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}